import { CronExpressionParser } from 'cron-parser';
import CronPrettifier from 'cronstrue';

export const DEFAULT_CRON_TIMEZONE = 'America/Sao_Paulo';
export const CRON_TIMEZONE_PREFIX = /^(?:CRON_TZ|TZ)=([^\s]+)\s+/;

export const extractCronTz = (cron: string): string => {
  const tzMatch = cron.trim().match(CRON_TIMEZONE_PREFIX);
  return tzMatch ? tzMatch[1] : 'UTC';
};

export const formatCron = (cron: string) => {
  const cronExpression = cron.trim().replace(CRON_TIMEZONE_PREFIX, '');
  return CronPrettifier.toString(cronExpression || '');
};

export function cronWithTimezone(expression: string, timezone: string) {
  if (/^[+-]/.test(timezone)) {
    throw new Error('Select an IANA timezone, such as America/Sao_Paulo.');
  }
  timezone = new Intl.DateTimeFormat('en', {
    timeZone: timezone,
  }).resolvedOptions().timeZone;
  const prefix = expression.trim().match(CRON_TIMEZONE_PREFIX);
  if (
    prefix &&
    new Intl.DateTimeFormat('en', { timeZone: prefix[1] }).resolvedOptions()
      .timeZone !== timezone
  ) {
    throw new Error(
      'The expression timezone must match the selected timezone.',
    );
  }
  const pattern = expression.trim().replace(CRON_TIMEZONE_PREFIX, '');
  const fields = pattern.split(/\s+/);
  if (
    !/^@(yearly|annually|monthly|weekly|daily|midnight|hourly)$/.test(pattern)
  ) {
    if (fields.length !== 5 && fields.length !== 6) {
      throw new Error('Use five cron fields, or six including seconds.');
    }
    checkCronFields(fields);
  }
  CronExpressionParser.parse(pattern, { tz: timezone });
  return `CRON_TZ=${timezone} ${pattern}`;
}

function checkCronFields(fields: string[]) {
  const withoutNames = fields
    .join(' ')
    .replace(
      /\b(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC|SUN|MON|TUE|WED|THU|FRI|SAT)\b/gi,
      '',
    );
  if (/[LWH#]/i.test(withoutNames)) {
    throw new Error(
      'Use standard cron syntax; L, W, # and H are not supported.',
    );
  }
  const weekdays = fields[fields.length - 1].split(',');
  if (
    weekdays.some((part) =>
      part
        .split('/')[0]
        .match(/\d+/g)
        ?.some((value) => Number(value) > 6),
    )
  ) {
    throw new Error('Use 0–6 for weekdays; Sunday is 0 or SUN.');
  }
}
